// src/styles/theme.js
const size = {
    desktop: '1920px',
    laptop: '1366px',
    tablet: '768px',
    mobile: '576px',
};
  
export const theme = {
    // 모니터 (FHD)
    desktop: `(max-width: ${size.desktop})`,
    // 일반 노트북 (가장 많이 쓰임)
    laptop: `(max-width: ${size.laptop})`,
    // 아이패드/태블릿 세로
    tablet: `(max-width: ${size.tablet})`,
    // 일반적인 스마트폰 (아이폰 등)
    mobile: `(max-width: ${size.mobile})`,
};